import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import { ButtonLink } from '..';
import { fetchOrderDetails } from '../../../actions';
import { ROUTES } from '../../../constants';
import { redirectToPath } from '../../../utils/window';

type Props = {
  history: Object,
  onFetchOrderDetails: Function,
};

class MyAccountLinkComponent extends Component<Props> {
  handleClick = () => {
    const { history, onFetchOrderDetails } = this.props;
    onFetchOrderDetails(history);
    const pathname = isMobile
      ? ROUTES.PATH.MOBILE_ACCOUNT_PROFILE
      : ROUTES.PATH.ACCOUNT_PROFILE;
    redirectToPath(pathname);
  };

  render() {
    return (
      <ButtonLink
        dataId="backToMyAccount"
        content="Back to My Account"
        onClick={this.handleClick}
      />
    );
  }
}

const mapDispatchToProps = {
  onFetchOrderDetails: fetchOrderDetails,
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(MyAccountLinkComponent)
);
